// 参数widghts：值为控件名称,例如：cpt-input，cpt-select。如果为all-widgets代表全部控件
// 参数properties：name新添加的属性名称，default为默认值
const addParams = 
    [
        {
            widget:'all-widgets',
            properties:[
                {name:'eventList',default:[]},
            ]
        }
    ]

export default addParams